import { useTranslation } from "react-i18next";
import { useChatAI } from "./chat-ai-context";
import { ContainerWizard } from "./wizards/container-wizard";
import { OrderWizard } from "./wizards/order-wizard";
import { QuoteRequestWizard } from "./wizards/quote-request-wizard";
import { QuoteResponseWizard } from "./wizards/quote-response-wizard";

export const ConversationalFormWizard = () => {
    const { activeWizard, setActiveWizard, setWizardFormData, appendMessage, setQuoteRequestId } = useChatAI();
    const { t } = useTranslation(['common', 'pages:containers', 'pages:orders', 'pages:quotes']);

    const handleCancel = () => {
        setActiveWizard(null);
        setWizardFormData({});
        setQuoteRequestId(null);
        appendMessage({
            role: "assistant",
            content: t('aiChat.wizard.cancelled'),
        });
    };

    if (!activeWizard) {
        return null;
    }

    switch (activeWizard) {
        case "container":
            return <ContainerWizard onCancel={handleCancel} />;
        case "order":
            return <OrderWizard onCancel={handleCancel} />;
        case "quote_request":
            return <QuoteRequestWizard onCancel={handleCancel} />;
        case "quote_response":
            return <QuoteResponseWizard onCancel={handleCancel} />;
        default:
            return null;
    }
};

